'use strict';
import React from 'react';
import ReactDom from 'react-dom';
import LeaveList from './leaveList';


class LeaveBody extends React.Component {
    constructor(props) {
        super(props);
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchMove = this.onTouchMove.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleMouseScroll = this.handleMouseScroll.bind(this);
        this.state={
            dragging: false,
            refX: 0,
            ini: 0,
        };
    }
    componentDidMount() {
        if (document.body.clientWidth > 768) {
            let elem = ReactDom.findDOMNode(this.refs.table);
            elem.addEventListener('mouseup', this.onTouchEnd);
            elem.addEventListener('mouseleave', this.onTouchEnd);
            elem.addEventListener('mousemove', this.onTouchMove);
            elem.addEventListener('mousedown', this.onTouchStart);
            window.addEventListener('wheel', this.handleMouseScroll);
        }
        window.addEventListener('scroll', this.handleScroll);
    }
    componentWillUnmount() {
        if (document.body.clientWidth > 768) {
            let elem = ReactDom.findDOMNode(this.refs.table);
            elem.removeEventListener('mouseup', this.onTouchEnd);
            elem.removeEventListener('mouseleave', this.onTouchEnd);
            elem.removeEventListener('mousemove', this.onTouchMove);
            elem.removeEventListener('mousedown', this.onTouchStart);
            window.removeEventListener('wheel', this.handleMouseScroll);
        }
        window.removeEventListener('scroll', this.handleScroll);
    }
    handleMouseScroll(e) {
        e.preventDefault();

        if (e.deltaY > 0) {
            //scroll down
            window.scrollBy(0, 50);
        } else {
            //scroll up
            window.scrollBy(0, -50);
        }

    }
    handleScroll(e) {
        let elem1 = ReactDom.findDOMNode(this.refs.est);
        let elem2 = ReactDom.findDOMNode(this.refs.table);
        console.log(elem2.getBoundingClientRect().top );
        if (elem2.getBoundingClientRect().top <= 50) {

            elem1.style.position = "absolute";
            
            if (document.body.clientWidth > 768) {
                elem2.style.paddingTop="50px";
                elem1.style.top = 50 - elem2.getBoundingClientRect().top + "px";
            } else {
                elem2.style.paddingTop="0px";
                elem1.style.top = -elem2.getBoundingClientRect().top + "px";
            }
        } else {
            elem2.style.paddingTop="0px";
            elem1.style.position = "relative";
            elem1.style.top = "0px";
        }

    }
    onTouchStart(e) {
        if (!this.state.dragging) {
            let touches = e.changedTouches;
            let refX;
            if (e.touches) {
                refX = e.touches[0].clientX;
            } else {
                refX = e.clientX;
            }
            let ini = ReactDom.findDOMNode(this.refs.table).scrollLeft;
            this.setState({
                ini: ini,
                refX: refX,
                dragging: true,
            });
        } else {
            this.setState({
                dragging: false
            });
        }
    }

    onTouchMove(e) {
        e.preventDefault();
        if (this.state.dragging && e.target) {
            let deltaX;
            if (e.touches) {
                deltaX = parseInt(this.state.refX - e.touches[0].clientX);
            } else {
                deltaX = parseInt(this.state.refX - e.clientX);
            }

            ReactDom.findDOMNode(this.refs.table).scrollLeft = (this.state.ini + deltaX);
        } else {
            this.setState({
                dragging: false
            });
        }
    }

    onTouchEnd(e) {
        this.setState({
            dragging: false,
        });
    }
    render() {

        return (
            <div className="atd-bd-wp" ref="table">
                <div className="atd-em-lt">
                    <table className="leave-tb tb-heading" ref="est">
                        <thead>
                            <tr>
                                <th>Date of Application</th>
                                <th>Day</th>
                                <th>Submitted By</th>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <th>Type</th>
                                <th>Duration</th>
                                <th>Status</th>
                                <th>MC</th>
                                <th>Receipt</th>
                                <th>Remark</th>
                                <th></th>
                            </tr>
                        </thead>
                    </table>
                    <LeaveList leaves={this.props.leaves} history={this.props.history} processing={this.props.processing} />
                </div>
            </div>
        );
    }
}
export default LeaveBody;


// WEBPACK FOOTER //
// ./app/components/leaveComponents/leaveBody.js